<template>
    <CElementCover :opacity="0.8" style="z-index:100" v-show="showLoading || (show && show === showIn)" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Loading',

    props: {
        showLoading: {
            default: false,
            type: Boolean
        },
        showIn: {
            default: true,
            type: [String, Boolean]
        }
    },

    computed: {
        ...mapGetters('loadingComponent', [
            'show'
        ])
    },
}
</script>